module.exports = __webpack_public_path__ + "img/chest-open.9b374ef0.png";